<template>
  <div class="main">
    <div class="header">
      <div class="header-text">
        <div class="hello">
          Hello,{{ shopInfo.userName ? shopInfo.userName : shopInfo.mobile }}
        </div>
        <div class="shopName">{{ shopInfo.name }}</div>
      </div>
    </div>
    <div class="notices">
      <van-cell-group>
        <van-cell title="定制订单" @click="toCustomOrder">
          <template #right-icon>
            <van-badge :content="customQty"> </van-badge>
          </template>
        </van-cell>
        <van-cell title="订单流水" @click="toWater">
          <template #right-icon>
            <van-icon name="arrow" />
          </template>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import { apiPost } from "@/api/common";
// 引入vant组件库

export default {
  name: "OrderCenter",
  data() {
    return {
      shopInfo: "",
      customQty: 0
    };
  },
  components: {},
  created() {
    this.loadComments();
    this.getCustomOrder();
  },
  methods: {
    loadComments() {
      let s = sessionStorage.getItem("shopInfo");
      this.shopInfo = s ? JSON.parse(s) : "";
    },
    getCustomOrder() {
      let _this = this;
      let url =
        "/api/productionDemandOrderController/findAllProductionDemandOrder";
      let data = {
        storeId: this.shopInfo.id,
        pageNum: 1,
        pageSize: 1,
        status: 0,
        shopCode: this.shopInfo.shopCode
      };
      apiPost(url, data).then(resp => {
        let _data = resp.data;
        let _code = _data.code;
        if (_code == "0000") {
          _this.customQty = _data.totalCount;
        }
      });
    },
    toCustomOrder() {
      this.$router.push({
        name: "CustomOrder"
      });
    },
    //去往订单流水页面
    toWater() {
      this.$router.push({
        name: "keepOrderWater"
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../assets/css/orderCenter.less");
</style>
